import React from "react";
import { Logo } from "./Logo";
import { CtaButton } from "./CtaButton";
import { images } from "../data/content";
export function Hero() {
  return <header className="bg-white px-4 pb-14 pt-10" data-id="element-80" data-mp="eilgvcukh9gq">
      <div className="mx-auto max-w-5xl text-center" data-id="element-81" data-mp="9ka2qpx8ocsp">
        <Logo data-id="element-82" data-mp="9ipchchyjg0n" />
        <h1 className="mt-10 font-heading text-3xl font-bold uppercase leading-tight md:text-5xl" data-id="element-83" data-mp="4lqiqv27hb2z">
          <span className="text-brand" data-id="element-84" data-mp="129h2fs8fj8fj">You've got the tools and the drive</span>{" "}
          <span className="text-ink" data-id="element-85" data-mp="127ecf87a1fat">but not the plans?</span>
        </h1>
        <h2 className="mt-8 font-heading text-2xl font-bold uppercase leading-tight md:text-4xl" data-id="element-86" data-mp="xaxgvsxqzynp">
          Build clever <span className="text-brand" data-id="element-87" data-mp="s9gic42qkoaa">2-in-1 wood projects</span> without the guesswork
        </h2>
        <p className="mx-auto mt-5 max-w-3xl text-base leading-relaxed text-ink-muted md:text-lg" data-id="element-88" data-mp="nbyir4alzley">
          Get <strong className="text-ink" data-id="element-89" data-mp="3czfkfwx3o34z">150+ downloadable woodworking plans</strong> with{" "}
          <strong className="text-ink" data-id="element-90" data-mp="3814c5qmge0ov">step-by-step guides</strong>, precise dimensions{" "}
          <strong className="text-ink" data-id="element-91" data-mp="3j928hxbf86zr">(inches + mm/cm)</strong> and ready-made cut lists, so you can build faster, easier{" "}
          <strong className="text-ink" data-id="element-92" data-mp="3o59cvlo65afl">and with total confidence.</strong>
        </p>
        <img src={images.hero} alt="Woodworking plan collection with book, box and hard hat" className="mx-auto mt-10 w-full max-w-4xl" data-id="element-93" data-mp="39cfmh57cz9w5" />
        <div className="mt-8" data-id="element-94" data-mp="30hhq1o505f02">
          <CtaButton label="Start building today" caption="Instant download · 30-day guarantee" data-id="element-95" data-mp="30h9crv4yw7oc" />
        </div>
      </div>
    </header>;
}